export default __webpack_public_path__ + "assets/Picture5.png";